export default __webpack_public_path__ + "static/media/Icons_Berth Icon.336eef6f.svg";